import * as S from "./styles";

const Loading = () => {
  return (
    <S.LoadingOverlay>
      <S.LoadingWrapper>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </S.LoadingWrapper>
    </S.LoadingOverlay>
  );
};

export default Loading;
